import { store } from 'redux/store';

import { Partner, Society } from 'types';

import { getDocument } from 'modules/documents/redux/documentActions';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';
import { isPlatformAXA } from 'utils/showDetails';

type GenerateCapitalHoldingCertificateProps = {
  partner: Partner | null;
  society: Society;
};

type LanguageMap = {
  [key: string]: string | undefined;
};

const getDocumentName = (partner: Partner | null): string => {
  const partnerLanguage = isPlatformAXA ? 'es' : partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: `Certificado de Patrimonio - ${partner?.partnerNumber}.pdf`,
    cat: `Certificat de Patrimoni - ${partner?.partnerNumber}.pdf`,
  };

  return (languageMap[partnerLanguage] || languageMap.es) as string;
};

const getCapitalHoldingCertificateDocumentId = (
  society: Society,
  partner: Partner | null
) => {
  const partnerLanguage = partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: society?.templates?.capitalHoldingCertificateES,
    cat: society?.templates?.capitalHoldingCertificateCA,
  };

  return languageMap[partnerLanguage];
};

const getCapitalHoldingCertificateFooterDocumentId = (society: Society) =>
  society?.templates?.capitalHoldingCertificateFooter;

const getPartnerId = (partner: Partner | null) => partner?.['_id'];

const getDocumentIds = (society: Society, partner: Partner | null) => {
  const capitalHoldingCertificateDocumentId =
    getCapitalHoldingCertificateDocumentId(society, partner);
  const capitalHoldingCertificateFooterDocumentId =
    getCapitalHoldingCertificateFooterDocumentId(society);

  return {
    capitalHoldingCertificateDocumentId,
    capitalHoldingCertificateFooterDocumentId,
  };
};

export const generateCapitalHoldingCertificate = async ({
  partner,
  society,
}: GenerateCapitalHoldingCertificateProps) => {
  const documentName = getDocumentName(partner);

  const {
    capitalHoldingCertificateDocumentId,
    capitalHoldingCertificateFooterDocumentId,
  } = getDocumentIds(society, partner);

  const capitalHoldingCertificateFooterDocument = await store.dispatch(
    getDocument(capitalHoldingCertificateFooterDocumentId)
  );
  const partnerId = getPartnerId(partner);

  const sources = {
    partner: partnerId,
  };

  const language = isPlatformAXA ? 'es' : partner?.language || 'es';

  if (capitalHoldingCertificateDocumentId && partnerId) {
    await generateDocumentWithTags({
      documentId: capitalHoldingCertificateDocumentId,
      documentName,
      sources,
      language,
      footerHtml: capitalHoldingCertificateFooterDocument?.editorModel || '',
      showOnlyValues: false,
    });
  }
};
